import { RulesData } from "@/utils/apis/rules_repository";
import React from "react";
import { TextField } from '@mui/material';
import { Text } from '../../../../Text';
import { SelectDropDown } from '../../../../inputs/SelectDropDown';
import AppliedTenants from "../DetailComponents/AppliedTenants";

// for applied / other users, groups and tenants -> show AutoComplete_Input field
// pass applied and non applied users, groups and tenants to each field
// store values here in the state. Pass it down with submit option. pass new rule up to the parent component
interface GracePeriodsInterface {
    [tenant: string]: number; // Use tenant names as keys and store string values
}
interface GracePeriodProps {
    rule: RulesData;
    tenants: string[];
    appliedTenants: string[];
    gracePeriods: GracePeriodsInterface;
    setGracePeriods: React.Dispatch<React.SetStateAction<GracePeriodsInterface>>;
    setAppliedTenants: React.Dispatch<React.SetStateAction<string[]>>;
    setDataChanged: React.Dispatch<React.SetStateAction<boolean>>;
}

export const GracePeriod: React.FC<GracePeriodProps> = ({ rule, tenants, appliedTenants, setAppliedTenants, gracePeriods, setGracePeriods, setDataChanged }) => {
    return (
        <>
            <AppliedTenants tenants={tenants} appliedTenants={appliedTenants} setAppliedTenants={setAppliedTenants} setDataChanged={setDataChanged} isDisabled={true}/>
            
            <Text as='p'> Grace Periods </Text>
            
            {appliedTenants.map((tenant) => {
                return (
                    <div className='wrapper' key={tenant}>
                        <div className='bg-white py-4'>
                            <TextField
                                id="clean"
                                variant="standard"
                                InputProps={{
                                    disableUnderline: true,
                                }}
                                contentEditable={false}
                                margin='none'
                                disabled
                                defaultValue={tenant}
                            />
                        </div>
                        <div>
                            <SelectDropDown className="bg-white" onChange={(e) => {
                                setGracePeriods({ ...gracePeriods, [tenant]: parseInt(e.target.value) });
                                setDataChanged(true);
                            }
                            } value={
                                gracePeriods[tenant] ? gracePeriods[tenant] : parseInt(rule.value)
                            }>
                                <option value={15}>15 Minutes</option>
                                <option value={30}>30 Minutes</option>
                                <option value={45}>45 Minutes</option>
                                <option value={60}>1 Hour</option>
                                <option value={120}>2 Hours</option>
                                <option value={180}>3 Hours</option>
                                <option value={240}>4 Hours</option>
                                <option value={360}>6 Hours</option>
                                <option value={720}>12 Hours</option>
                            </SelectDropDown>
                        </div>
                    </div>
                )
            }
            )}
        </>
    );
};

export default GracePeriod;